<template>
  <div>
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
          Result
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Result</a>
          </li>
      </ul>
    </div>
    <hr>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <b-row>
            <b-col>
              <strong>Scan Result Datail</strong>
              <strong style="float:right;">Check Time {{model.scan_time | datetime}}</strong>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>Agent</div>
                <div title="" v-if="model && model.agent">
                  {{model.agent.name}}
                  <span v-if="model.agent.name != model.agent.host">
                    ({{model.agent.host}})
                  </span>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>IP Address(Public)</div>
                <div title="" v-if="model && model.agent">{{model.agent.ip_addr_public}}</div>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>IP Address(Private)</div>
                <div title="" v-if="model && model.agent">{{model.agent.ip_addr_private}}</div>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col md="3">
              <b-form-group>
                <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="Displays the time spent on the inspection Displays approximate time for manual checks">
                  Scanning Time
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </span>
                <div>
                  {{model.scanning_time}}
                </div>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <div class="m-1" v-b-tooltip.hover>Check Folder / Check File</div>
                <div>{{model.scan_folder | number}} Checked / {{model.scan_count | number}} Checked </div>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="Displays the time spent on the inspection">
                  Detect Count
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </span>
                <div> {{model.detect_count | number}}</div>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="Displays the number of detected history quarantined because it corresponds to isolation mode">
                  Isolation Count
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </span>
                <div> {{model.backup_count | number}} </div>
              </b-form-group>
            </b-col>
          </b-row>
          <hr v-if="model.setting && model.setting.rule">
          <b-row v-if="model.setting && model.setting.rule">
            <b-col md="12">
              <b-button block href="#" variant="success" v-b-tooltip.hover.top title="Displays the inspection policy when the inspection is carried out" class="btn-add">
                Setting
                <span>
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </b-button>
            </b-col>
          </b-row>
          <hr v-if="model.setting && model.setting.rule">
          <b-row class="text-center" v-if="model.setting && model.setting.rule">
            <b-col>
              <b-form-group :label-cols="4">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="Set the policy to be used for inspection">
                    * Scan Policy
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>

                </div>
                <b-form-checkbox-group id="ph_status" v-model="model.setting.rule" :disabled="true">
                  <b-form-checkbox value="Regex">Regex</b-form-checkbox>
                  <b-form-checkbox value="Hash">Hash</b-form-checkbox>
                  <b-form-checkbox value="Url">Url</b-form-checkbox>
                  <b-form-checkbox value="Ssdeep">Ssdeep</b-form-checkbox>
                  <b-form-checkbox value="OB">Obfuscation</b-form-checkbox>
                  <!-- <b-form-checkbox value="ML">Machine Learning</b-form-checkbox> -->
                </b-form-checkbox-group>
              </b-form-group>
              <br>
              <b-form-group :label-cols="4">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="Set whether to monitor in real time">
                    Real-time monitoring
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-form-radio-group :disabled="true" id="ph_realtime_mode_type" v-model="model.setting.realtime_mode">
                  <b-form-radio :value="true">Enable</b-form-radio>
                  <b-form-radio :value="false">Disable</b-form-radio>
                </b-form-radio-group>
              </b-form-group>

            </b-col>
            <b-col class="border-left">
              <b-form-group :label-cols="4" label="">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="Set the inspection schedule A maximum of 10 configurations is recommended at dawn or at a time when there is no load on the server resources">
                    * Check Schedule
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                    <br>
                    <small>Up to 10 schedules can be set</small>
                  </span>
                </div>
                <Schedule :readonly="true" :now_schedule="model.setting.schedule" :hide_text="true" />
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col>
              <b-form-group :label-cols="2">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="Sets whether detected Web shell files are backed up The file is not accessible from the web after the backup This is a recommended setting, but files in typos may be backed up">
                    Isolation mode
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-form-radio-group :disabled="true" style="display:inline-block" v-model="model.setting.backup_mode">
                  <b-form-radio :value="false">Manual</b-form-radio>
                  <b-form-radio :value="true">Automatic</b-form-radio>
                </b-form-radio-group>
                [
                <b-form-checkbox-group :disabled="true" style="display:inline-block" v-model="model.setting.backup_type_list">
                  <b-form-checkbox value="Regex">Regex</b-form-checkbox>
                  <b-form-checkbox value="Hash">Hash</b-form-checkbox>
                  <b-form-checkbox value="Url">Url</b-form-checkbox>
                  <b-form-checkbox value="Ssdeep">Ssdeep</b-form-checkbox>
                  <!-- <b-form-checkbox value="OB">Obfuscation</b-form-checkbox> -->
                  <!-- <b-form-checkbox value="OB">난독화</b-form-checkbox> -->
                  <!-- <b-form-checkbox value="ML">Machine Learning</b-form-checkbox> -->
                </b-form-checkbox-group>
                ] <br> <small class="text-danger">* Obfuscation cannot use automatic isolation</small>
              </b-form-group>
            </b-col>
            <b-col class="border-left">
              <b-form-group :label-cols="3">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.bottom title="Set the isolation path If the path does not exist, it automatically creates a folder on that path Defaults to 'C:\wfinder_backup' for Windows and '/opt/f1/wsfinder_backup' for Linux are set to default at installation">
                    Isolation Path
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-input-group>
                  <b-form-input placeholder="require the folder path" :disabled="true" id="input-small3" type="text" v-model="model.setting.backup_path"></b-form-input>
                  <!-- <b-button size="sm" variant="link" @click="modal_scan_list_history = true">이전 기록</b-button> -->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <b-col>
              <hr>
              <b-button style="position: relative; top:-30px; width: 80%;" v-b-toggle.collapse-1-inner size="sm" variant="light">More Options</b-button>
            </b-col>
          </b-row>

          <b-collapse id="collapse-1-inner" class="mt-2">
            <b-row>
              <b-col>
                <b-form-group :label-cols="3">
                  <div slot="label" class="font-weight-bold">
                    <span v-b-tooltip.hover.right title="You can filter by extension in the inspection target Use to monitor only specific files">
                      Extention setting
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </span>
                  </div>
                  <b-input-group>
                    <b-form-input :disabled="true" type="text" v-model="converter"></b-form-input>
                  </b-input-group>
                  <small class="help-block">Extention setting, Example) txt,php,aspx,js, ...</small>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group :label-cols="3">
                  <div slot="label" class="font-weight-bold">
                    <span v-b-tooltip.hover.right title="Scan only files with sub-conditions size in the folder you monitor">
                      Maximum file size
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </span>
                  </div>
                  <b-input-group>
                      <b-form-input :disabled="true" type="number" v-model="model.setting.max_filesize"></b-form-input>
                  </b-input-group>
                  <small class="help-block">Default : 10M</small>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group :label-cols="3">
                  <div slot="label" class="font-weight-bold">
                    <span v-b-tooltip.hover.right title="Sets whether an updated system pattern is automatically applied to check It is recommended that these settings be enabled If not used, you can update the updated pattern manually">
                      Automatically apply patterns
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </span>
                    <!-- 시스템 패턴 자동 적용 -->
                  </div>
                  <b-form-radio-group v-if="model.setting" v-model="model.setting.is_allow_system" :disabled="true">
                    <b-form-radio :value="true">Enable</b-form-radio>
                    <b-form-radio :value="false">Disable</b-form-radio>
                    <b-button class="btn-add" size="sm" variant="success" :disabled="true">
                      <b-badge pill variant="warning" >{{ model.available_system_pattern_count | number }}</b-badge>
                      <span v-if="!model.is_testing">
                        Additional system patterns can be applied
                      </span>
                      <span v-else>
                        Request test, email the result to you
                      </span>
                    </b-button>
                  </b-form-radio-group>
                  <small class="text-danger">recommend using it</small>
                </b-form-group>
              </b-col>
            </b-row>
          <!--  <hr>
          <b-row class="text-center">
            <b-col sm="12">
              <p style="display:inline-block; cursor: pointer;" @click="model.setting.limit_mode = !model.setting.limit_mode">
                <span v-b-tooltip.hover.right title="설치된 서버의 자원을 모니터링 합니다 설정한 한계치 도달시 메일 알림을 수신할 수 있습니다">
                  자원 모니터링 알림
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </span>
                <i v-if="model.setting.limit_mode" class="fa fa-refresh fa-spin"></i>
              </p>
              <c-switch :disabled="true" class="float-right" color="success" label variant="pill" v-model="model.setting.limit_mode"/>
              <br>
              <small class="text-danger">시스템 자원이 임계치 이상일 경우 최초 1회 알림 발생 되며, 정상 기준이하시 재알림이 가능합니다. 임계치는 90%, 정상 기준은 60% 를 권장합니다 </small>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col sm="2" class="mt-2">CPU 임계치(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM 임계치(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk 임계치(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <b-col sm="2" class="mt-2">CPU 정상(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM 정상(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk 정상(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row> -->
        </b-collapse>
          <hr>
          <b-row>
            <b-col md="12">
              <b-button block href="#" variant="danger">
                Detect List
              </b-button>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col md="12">
              <b-form-group>
                <pre class="text-left" v-if="detect_list" style="margin:0 auto; background-color:#f5f5f5; border:1px solid #ccc; padding:10px; max-height: 500px; max-width: 1500px; overflow: auto;">{{detect_list}}</pre>
                <span v-else>No have detected something</span>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-button v-if="!(id || result_data) && detect_list.length" size="sm" variant="success" @click="save_rs" class="btn-add"> Download </b-button>
          <b-button block v-if="(id || result_data) && detect_list.length" size="sm" variant="success" @click="save_rs" class="btn-add"> Download </b-button>
          <b-button v-if="!id && !result_data" size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
